<template>
  <h1>{{ i18n.app.components.about.about }}</h1>
</template>

<script>
export default {
  mounted() {}
};
</script>
